import { number, shape, string } from "prop-types";

export const SupplierShape = shape({
  product_count: number,
  id: string,
  name: string
});

export default SupplierShape;
